// ─────────────────────────────────────────────────────────────────────────────
// ReviewStep.js — step 3. Read-only summary of everything collected, plus the
// "expires in 7 days" warning note.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../InviteModal.module.css";
import { buildReviewRows, inviteInitials } from "../inviteData";
import { InfoIcon } from "../icons";

export default function ReviewStep({ form }) {
  const rows = buildReviewRows(form);
  const name = `${form.firstName} ${form.lastName}`.trim() || "New User";

  return (
    <>
      <div className={styles.summary}>
        <div className={styles.summaryLabel}>Invitation Summary</div>

        <div className={styles.summaryUser}>
          <div className={styles.summaryAvatar}>{inviteInitials(form)}</div>
          <div>
            <div className={styles.summaryName}>{name}</div>
            <div className={styles.summaryEmail}>{form.email}</div>
          </div>
        </div>

        <div className={styles.summaryGrid}>
          {rows.map((r) => (
            <div key={r.key} className={styles.summaryCell}>
              <span className={styles.summaryKey}>{r.key}</span>
              <span className={styles.summaryVal}>{r.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={`${styles.note} ${styles.noteAmber}`}>
        <span className={styles.noteIcon}><InfoIcon /></span>
        <span>
          An invitation email will be sent to the user. They will need to accept
          the invite and complete setup within 7 days.
        </span>
      </div>
    </>
  );
}
